// Circular Kaira mark used in loaders + confirmation hero.
// Logo lives on thetarzanway's CDN — same asset the consumer site uses.

const SRC = "https://thetarzanway.com/KairaInsta.png";

interface Props {
  size?: number;
  className?: string;
}

export function KairaMark({ size = 44, className = "" }: Props) {
  return (
    <div className={`kaira-mark ${className}`.trim()} style={{ width: size, height: size }}>
      <img src={SRC} alt="Kaira" />
    </div>
  );
}
